import { createSelector } from 'reselect'

const organizations = state => state.api.organizations.listSOAs

const mapForDropdown = orgs => {
  return orgs.map(item => ({
    value: item.id,
    label: item.name
  }))
}

export default createSelector(organizations, mapForDropdown)
